import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setRoute('my_employee_discount'),
    MenuEntry.create()
        .setRoute('employee_discount_customer'),
    MenuEntry.create()
        .setRoute('employee_deactivated'),
];
